import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'alert/alertForm';

const alertFormService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  getViews: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/view`,
    });
  },

  getMessages: (data, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/messages/${encodeURIComponent(userId)}`,
      data,
    });
  },

  getMessageCount: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/messages/count/${encodeURIComponent(userId)}`,
    });
  },

  markMessageAsRead: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/messages/markAsRead`,
      data,
    });
  },
};
export default alertFormService;
